
import React from 'react';
import { cn } from '@/lib/utils';

type ActivityPriorityProps = {
  priority: 'low' | 'medium' | 'high';
  className?: string;
  showLabel?: boolean;
};

export const ActivityPriority: React.FC<ActivityPriorityProps> = ({ 
  priority,
  className,
  showLabel = true 
}) => {
  const priorityClasses = {
    low: 'bg-green-500',
    medium: 'bg-yellow-500',
    high: 'bg-red-500'
  };

  const priorityLabels = {
    low: 'Basse',
    medium: 'Moyenne',
    high: 'Haute'
  };

  return (
    <div className={cn('flex items-center gap-1.5', className)}>
      <span className={cn(
        'inline-block w-2.5 h-2.5 rounded-full',
        priorityClasses[priority]
      )} />
      {showLabel && (
        <span className="text-xs text-gray-600 dark:text-gray-400">
          {priorityLabels[priority]}
        </span>
      )}
    </div>
  );
};
